export const ADD_EDGE="ADD_EDGE";
export const REMOVE_EDGE="REMOVE_EDGE";
export const MODIFY_EDGE="MODIFY_EDGE";